<template>
  <div>
    <div class="mb-1 tw-text-xl tw-font-bold tw-mb-3">
      {{ headerTitle}}
    </div>
  <v-card id="table-wht" min-height="740">
    <v-container fluid>
      <h1 class="tw-font-bold tw-pb-4"> เงื่อนไข การค้นหาและการส่งออกข้อมูล</h1>
      <div class="input-group tw-grid tw-grid-cols-2 tw-gap-14 tw-max-w-4xl tw-text-base tw-mb-3">
        <div class="left-col tw-gap-2 tw-grid tw-grid-cols-1 tw-items-center">
            <div class="tw-grid tw-grid-cols-2 tw-items-center">
                <div class="tw-whitespace-nowrap">จากวันที่เอกสาร</div>
                <v-menu
                v-model="fromDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field dense
                    label="จากวันที่เอกสาร"
                    prepend-inner-icon="mdi-calendar-month-outline"
                    readonly
                    :value="fromDateDisp"
                    v-on="on"
                    outlined
                    class="tw-p-0 tw-m-0 tw-items-center"
                    @click:clear="fromDateVal = null"
                  >
                </v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  locale="en-in"
                  v-model="fromDateVal"
                  no-title
                  @input="fromDateMenu = false"
                  :min="minDate"
                ></v-date-picker>
                </v-menu>
            </div>
            <div class="tw-grid tw-grid-cols-2 tw-items-center">
              <div class="tw-whitespace-nowrap">ถึงวันที่เอกสาร</div>
              <v-menu
                v-model="toDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                :disabled="fromDateVal == null"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field dense
                    label="ถึงวันที่เอกสาร"
                    prepend-inner-icon="mdi-calendar-month-outline"
                    readonly
                    outlined
                    :value="toDateDisp"
                    v-on="on"
                    :disabled="fromDateVal == null"
                    class="tw-p-0 tw-m-0 tw-items-center"
                    @click:clear="toDateVal = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  locale="en-in"
                  v-model="toDateVal"
                  no-title
                  @input="toDateMenu = false"
                  :min="minToDate"
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="tw-grid tw-grid-cols-2 tw-items-center">
              <div class="tw-whitespace-nowrap">สาขากิจการ</div>
              <v-select
                item-text="value"
                item-value="key"
                label="เลือกสาขากิจการ"
                :items="branchList"
                outlined
                v-model="filterData.branchID"
                class="tw-m-0 tw-p-0 inputted-green"
                clearable
                hide-details
                dense
                :menu-props="{ top: false, offsetY: true}"
              ></v-select>
            </div>
            <div class="tw-grid tw-grid-cols-2 tw-items-center">
              <div class="tw-whitespace-nowrap">ประเภท ภ.ง.ด</div>
                <v-select
                item-text="value"
                item-value="key"
                label="เลือกประเภท ภ.ง.ด"
                :items="['ภ.ง.ด.3', 'ภ.ง.ด.53']"
                class="tw-m-0 tw-p-0 inputted-green"
                outlined
                v-model="filterData.taxType"
                :menu-props="{ top: false, offsetY: true}"
                clearable
                dense
              ></v-select>
            </div>
          <div
              v-if="transactionStatus !== 'Cancel'"
              class="tw-grid tw-grid-cols-2 tw-items-center">
              <div class="tw-whitespace-nowrap">WHT Filing Status</div>
                <v-select
                item-text="statusName"
                label="เลือก WHT Filing Status"
                :items="fillingStatus"
                class="tw-m-0 tw-p-0 inputted-green"
                outlined
                v-model="filterData.fillingStatus"
                :menu-props="{ top: false, offsetY: true}"
                clearable
                dense
                return-object
              ></v-select>
            </div>
            
        </div>
        <div class="right-col tw-gap-2 tw-grid tw-grid-cols-1 tw-items-center">
          <div class="tw-grid tw-grid-cols-2 tw-items-center">
            <div>จากเลขที่เอกสาร WHT</div>
            <v-text-field dense
            label="จากเลขที่เอกสาร WHT"
            placeholder="จากเลขที่เอกสาร WHT"
            class="tw-m-0 tw-p-0 tw-text-right inputted-green"
            v-model="filterData.fromNo"
            outlined
            clearable
            hide-details
            ></v-text-field>
          </div>
          <div class="tw-grid tw-grid-cols-2 tw-items-center">
            <div>ถึงเลขที่เอกสาร WHT</div>
            <v-text-field dense
            :label="`ถึงเลขที่เอกสาร WHT`"
            :placeholder="`ถึงเลขที่เอกสาร WHT`"
            outlined
            class="tw-m-0 tw-p-0 inputted-green"
            v-model="filterData.toNo"
            :disabled="filterData.fromNo === ''"
            clearable
            ></v-text-field>
          </div>
          <div class="tw-grid tw-grid-cols-2 tw-items-center">
            <div>ชื่อผู้ถูกหัก</div>
              <v-text-field 
                :value="keyword"
                :label="`ค้นหาจาก ชื่อผู้ถูกหัก`"
                :placeholder="`ค้นหาจาก ชื่อผู้ถูกหัก`"
                @input="debounceInput"
                outlined
                dense
                hide-details
              ></v-text-field>
          </div>
          <div class="tw-grid tw-grid-cols-1 tw-gap-3 tw-items-center place-items-center">
              <div class="tw-flex tw-justify-end tw-gap-2">
                <v-btn
              outlined
              color="deep-orange lighten-3"
              class="tw-m-0 tw-p-0 btn-ns-reset"
              @click="resetSearchData"
              >
          
              ล้าง
            </v-btn>
                <v-btn
                color="primary"
                class="tw-m-0 tw-px-0 btn-ns-search tw-self-center"
                @click="() => handleSearchClick()"
                depressed
                >
                <v-icon small>mdi-magnify</v-icon>
                  การค้นหา
                </v-btn>
              <v-btn color="primary"  class="white--text tw-m-0 tw-px-0 btn-ns-search tw-self-center" style="font-size: 14px" @click="exportExcel">
                  Export Excel
              </v-btn>
              <v-btn
                v-if="canCancelTransaction && transactionStatus !== 'Cancel'"
                color="red"
                class="white--text tw-m-0 tw-px-0 btn-ns-search tw-self-center"
                style="font-size: 14px"
                @click="cancelDocDialog = true"
                :disabled="selectedList.length === 0"
              >
                ยกเลิกรายการ
              </v-btn>
              </div>
            </div>
        </div>
      </div>
      
    </v-container>
    <v-divider class="tw-pb-4" />
    <v-container v-if="alert.show">
      <v-row>
        <v-col cols="12">
          <v-alert
            v-model="alert.show"
            :type="alert.type"
            transition="scale-transition"
            dismissible
            >{{ alert.text }}</v-alert
          >
        </v-col>
      </v-row>
    </v-container>
    <!-- docs:: 
    {{ 
    docs.length
     }} -->

    <!-- <v-dialog v-model="pdfDialog">
      <div>
        <iframe class="iframe" :src="pdfSrc"></iframe>
      </div>
    </v-dialog> -->

    <PdfModal
      :model-value="showModal"
      @update:modelValue="showModal = $event"
      :pdfUrl="pdfSrc"
      :docID="modalID"
      :pdfDownloadCount="pdfDownloadCount"
      :pdfPrintCount="pdfPrintCount"
      @update:pdfDownloadCount="pdfDownloadCount = $event"
      @update:pdfPrintCount="pdfPrintCount = $event"
      :transactionStatus="transactionStatus"

    />

    <!-- Reset PDF dialog -->
    <v-dialog v-model="resetPdfDialog" max-width="460" @click:outside="cancelResetPdf">
      <v-card class="reset-pdf-card">
        <v-card-title class="reset-pdf-card__title">
          <div class="reset-pdf-card__title-icon">
            <v-icon color="white">mdi-refresh</v-icon>
          </div>
          <div>
            <div class="reset-pdf-card__heading">สร้าง PDF ใหม่</div>
            <div class="reset-pdf-card__subheading">ระบบจะสร้างไฟล์ PDF ของเอกสารนี้ขึ้นใหม่</div>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="reset-pdf-card__body">
          <div class="reset-pdf-row">
            <span class="reset-pdf-row__label">เลขที่เอกสาร</span>
            <span class="reset-pdf-row__value reset-pdf-row__value--mono">{{ (resetPdfTarget && (resetPdfTarget.documentID || resetPdfTarget.docID || resetPdfTarget.id)) || '—' }}</span>
          </div>
          <div v-if="resetPdfTarget && resetPdfTarget.payeeName" class="reset-pdf-row">
            <span class="reset-pdf-row__label">ผู้ถูกหักภาษี</span>
            <span class="reset-pdf-row__value">{{ resetPdfTarget.payeeName }}</span>
          </div>
          <div v-if="resetPdfTarget && resetPdfTarget.docWHTDate" class="reset-pdf-row">
            <span class="reset-pdf-row__label">วันที่</span>
            <span class="reset-pdf-row__value">{{ resetPdfTarget.docWHTDate }}</span>
          </div>

          <div class="reset-pdf-divider"></div>

          <div class="reset-pdf-checkbox-wrap">
            <v-checkbox
              v-model="resetPdfClearSignature"
              color="orange darken-1"
              hide-details
              :ripple="false"
              class="reset-pdf-checkbox tw-mt-0 tw-pt-0"
            >
              <template v-slot:label>
                <div class="reset-pdf-checkbox__label">
                  <div class="reset-pdf-checkbox__main">ล้างลายเซ็นด้วย</div>
                  <div class="reset-pdf-checkbox__hint">เลือกถ้าต้องการเซ็นใหม่</div>
                </div>
              </template>
            </v-checkbox>
          </div>

          <div
            class="reset-pdf-note"
            :class="{ 'reset-pdf-note--warning': resetPdfClearSignature }"
          >
            <v-icon
              small
              :color="resetPdfClearSignature ? '#b45309' : '#6b7280'"
              class="tw-mr-1"
            >{{ resetPdfClearSignature ? 'mdi-alert-outline' : 'mdi-information-outline' }}</v-icon>
            <span v-if="resetPdfClearSignature">
              <strong>ลายเซ็นจะถูกล้างด้วย</strong> — เอกสารใบนี้จะต้องเซ็นใหม่ก่อนสร้าง PDF
            </span>
            <span v-else>ลายเซ็นและข้อมูลในเอกสารยังอยู่ครบ ไม่ต้องกรอกใหม่</span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="tw-px-4 tw-py-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="cancelResetPdf"
            class="tw-text-gray-600"
            :disabled="!!(resetPdfTarget && resetPdfLoading[resetPdfTarget.id])"
          >ยกเลิก</v-btn>
          <v-btn
            color="orange darken-1"
            depressed
            class="white--text tw-ml-2"
            :loading="!!(resetPdfTarget && resetPdfLoading[resetPdfTarget.id])"
            @click="confirmResetPdf"
          >
            <v-icon left small>mdi-refresh</v-icon>
            สร้าง PDF ใหม่
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancelDocDialog" width="auto">
      <v-card class="tw-p-2">
        <v-card-title class="tw-text-xl tw-font-bold tw-text-red-600 tw-flex tw-items-center tw-gap-2">
          <v-icon color="red" large>mdi-alert-circle-outline</v-icon>
          ยืนยันการยกเลิกรายการ
        </v-card-title>
        <v-card-text class="tw-pt-4 tw-text-base">
          <div class="tw-whitespace-nowrap">คุณต้องการยกเลิกรายการที่เลือกจำนวน <b>{{ selectedList.length }}</b> รายการ ใช่หรือไม่?</div>
          <span class="tw-text-red-500 tw-text-sm">* สถานะเอกสารจะถูกเปลี่ยนเป็น Cancel</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDocDialog = false" class="tw-text-gray-600" :disabled="isCancellingTransaction">ยกเลิก</v-btn>
          <v-btn color="red" depressed class="white--text" @click="handleCancelDocClick()" :disabled="isCancellingTransaction">
            <v-icon left>mdi-cancel</v-icon>
            ยืนยันยกเลิกรายการ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr id="header-table">

            <th>
              <v-checkbox
                :value="selectedAll"
                color="#6ec39b"
                class="tw-mr-0"
                @change="clickSelectedAll($event)"
              ></v-checkbox>
            </th>

            <th
              class="text-left order-by-row"
              @click="changeOrderBy('paymentType')"
              v-if="showColumn('paymentType')"
            >
              ประเภทเอกสาร
              <img
                v-if="orderBySelect['key'] === 'paymentType'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'paymentType'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>

            <th
              class="text-left order-by-row"
              @click="changeOrderBy('internalDocument')"
            >
              เลขที่เอกสาร NS
              <img
                v-if="orderBySelect['key'] === 'internalDocument'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'internalDocument'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('documentID')"
            >
              เลขที่เอกสาร WHT
              <img
                v-if="orderBySelect['key'] === 'documentID'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'documentID'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('docDate')"
              v-if="showColumn('docDate')"
            >
              วันที่ WHT
              <img
                v-if="orderBySelect['key'] === 'docDate'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'docDate'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('payeeName')"
              v-if="showColumn('payeeName')"
            >
              ชื่อผู้ถูกหัก
              <img
                v-if="orderBySelect['key'] === 'payeeName'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'payeeName'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('payeeTaxId')"
              v-if="showColumn('payeeTaxId')"
            >
              เลขประจำตัวผู้ถูกหักภาษี
              <img
                v-if="orderBySelect['key'] === 'payeeTaxId'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'payeeTaxId'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-left order-by-row"
              @click="changeOrderBy('entityBranch')"
              v-if="showColumn('entityBranch')"
            >
              สาขาผู้ถูกหัก
              <img
                v-if="orderBySelect['key'] === 'entityBranch'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'entityBranch'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-right order-by-row"
              @click="changeOrderBy('taxWHSumBaseAmount')"
              v-if="showColumn('taxWHSumBaseAmount')"
            >
              มูลค่าฐานภาษี
              <img
                v-if="orderBySelect['key'] === 'taxWHSumBaseAmount'"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'taxWHSumBaseAmount'"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-right order-by-row"
              @click="changeOrderBy('taxWHSumAmount')"
              v-if="showColumn('taxWHSumAmount')"
            >
              มูลค่าภาษีที่หัก
              <img
                v-if="orderBySelect['key'] === 'taxWHSumAmount' && !keyword"
                src="/images/icons/icon-filter.svg"
                alt="filter"
                v-bind:class="{ 'filter-up': orderBySelect['value'] === 'asc' }"
                style="margin-left: 4px; display: inline-flex"
              />
              <v-icon
                dark
                color="#707070"
                v-if="orderBySelect['key'] !== 'taxWHSumAmount' && !keyword"
                class="icon-sort"
                >mdi-menu-swap</v-icon
              >
            </th>
            <th
              class="text-center order-by-row"
              v-if="showColumn('payeeAddress')"
            >
              ที่อยู่
            </th>
            <th
              class="text-center order-by-row"
            >
            ดาวน์โหลด/พิมพ์
            </th>
            <th
              class="text-center order-by-row"
              v-if="showColumn('link')"
            >
              ลิงก์
            </th>
            <th
              class="text-center"
              v-if="userCompany?.isDeveloper || user?.isEngineer"
            >
              สร้าง PDF ใหม่
            </th>
          </tr>
        </thead>
        <tbody>
          <TableLoadingOverlay :loading="isTableLoading" />
          <tr v-for="doc in data" :key="doc.id" class="tr-data">
            <td>
              <v-checkbox
                color="#6ec39b"
                :input-value="getCheckedSelect(doc.id)"
                class="remove-checkbox-padding shrink mr-0 mt-0"
                @change="clickSelected(doc)"
                hide-details
              ></v-checkbox>
            </td>

            <td
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ handlePayeeType(doc["paymentType"]) }}
            </td>
            <td
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["internalDocument"] }}
            </td>
            <td
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["documentID"] }}
            </td>

            <td
              v-if="showColumn('docDate')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <!-- {{ doc["docDate"] || "-" }} -->
              {{ getDateWithFormat(doc["docDate"]) }}
            </td>

            <!-- <td
              v-if="showColumn('entityBranch')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ getTaxId(doc["entityBranch"], companyID) }}
            </td> -->
            <td
              v-if="showColumn('payeeName')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <pre>{{ doc["payeeName"] }}</pre>
            </td>
            <td
              v-if="showColumn('payeeTaxId')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["payeeTaxId"] || "-" }}
            </td>

            <td
              v-if="showColumn('entityBranch')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["entityBranch"] }}
            </td>

            <td
              class="text-right"
              v-if="showColumn('taxWHSumBaseAmount')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ doc["taxWHSumBaseAmount"] }}
            </td>

            <td
              class="text-right"
              v-if="showColumn('taxWHSumAmount')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              {{ $formatCurrency(doc["taxWHSumAmount"]) || '0.00' }}
            </td>

            <td
              class="text-left"
              v-if="showColumn('payeeAddress')"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ handlePayeeAddress(doc.payeeAddress) }}
                  </span>
                </template>
                <span>{{ doc.payeeAddress }}</span>
              </v-tooltip>
            </td>

            <td
              class="text-center"
              @mousedown="startDrag"
              @mouseup="stopDrag(doc)"
              @mousemove="doDrag"
            >
              <div class="status-icons">
                 <!-- Download Count -->
                 <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="count-wrapper" v-bind="attrs" v-on="on">
                      <v-icon
                        dark
                        small
                        :color="getDownloadCount(doc) > 0 ? '#6ec39b' : '#707070'"
                      >
                        mdi-download-outline
                      </v-icon>
                    </div>
                  </template>
                  <span>ดาวน์โหลดแล้ว {{ getDownloadCount(doc) }} ครั้ง</span>
                </v-tooltip>

                <!-- Print Count -->
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="count-wrapper" v-bind="attrs" v-on="on">
                      <v-icon
                        dark
                        small
                        :color="getPrintCount(doc) > 0 ? '#6ec39b' : '#707070'"
                      >
                        mdi-printer-outline
                      </v-icon>
                    </div>
                  </template>
                  <span>พิมพ์แล้ว {{ getPrintCount(doc) }} ครั้ง</span>
                </v-tooltip>


              </div>
            </td>

            <td class="text-left" v-if="showColumn('link')">
              <v-btn
                color="primary"
                depressed
                icon
                outlined
                target="_blank"
                :href="doc.link ? doc.link : 'about:blank'"
              >
                <v-icon small> mdi mdi-file-document-edit-outline </v-icon>
              </v-btn>
              <v-btn
                v-if="user?.isEngineer"
                color="orange"
                depressed
                icon
                outlined
                target="_blank"
                class="ml-1"
                :href="getFirestoreDocUrl(doc.id)"
              >
                <v-icon small>mdi-firebase</v-icon>
              </v-btn>
            </td>
            <td
              class="text-center"
              v-if="userCompany?.isDeveloper || user?.isEngineer"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-btn
                      color="orange"
                      depressed
                      icon
                      outlined
                      :loading="!!resetPdfLoading[doc.id]"
                      :disabled="!!resetPdfLoading[doc.id] || (!doc['@PdfUrl'] && !doc['@PdfPath'])"
                      @click="onClickResetPdf(doc)"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>สร้างไฟล์ PDF ของเอกสารใบนี้ขึ้นใหม่</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-if="!isTableLoading && docs.length === 0" class="tw-text-center tw-w-full tw-opacity-80 tw-py-40">
      <h2>ไม่พบเอกสารที่ต้องการ</h2>
    </div>
    <v-progress-linear indeterminate color="green" :active="downloadPdfLoading"></v-progress-linear>
    <v-snackbar v-model="snackBarError" color="red" top centered timeout="3000">
      <span class="tw-text-center tw-block">{{ snackBarMsg }}</span>
    </v-snackbar>
    <v-snackbar v-model="snackBarSuccess" color="green" top centered timeout="3000">
      <span class="tw-text-center tw-block">{{ snackBarMsg }}</span>
    </v-snackbar>
  </v-card>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import "firebase/auth";
import isMobile from "../../../libs/detectMobile";
import moment from "moment";
import "moment/locale/th";
import PopoverMenu from "./popoverMenu";
import formatTwoDecimal from "@/libs/formatTwoDecimal";
import getErrorMessage from "@/libs/getErrorMessage";
import companyStatus from "@/libs/companyStatus";
import router from "@/router";
import getDocumentTypeKey from "@/libs/getDocumentTypeKey";
import isSalaDaengEmail from "@/libs/isSalaDaengEmail";
import libCSV from "@/libs/libCSV";
import MonthlyDownloadDialog from "./monthly-download-dialog.vue";
import Papa from "papaparse";
import thaismartTax from "@/store/collection/taxstore";
import PdfModal from '@/components/public/pdf-modal.vue';
import TableLoadingOverlay from "./TableLoadingOverlay.vue";
import * as XLSX from "xlsx";
const axios = require("axios");
const _ = require("lodash");

const MAX_DOC_PER_ZIP = {
  xml: 500,
  pdf: 100,
};

moment.locale("th");

export default {
  components: {
    PdfModal,
    TableLoadingOverlay,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      menu: false,
      filterData: {
        nsDocID: "",
        payeeName: "",
        branchID: "",
        taxType: "",
        fromNo: "",
        toNo: "",
        fromDate: "",
        toDate: "",
        fillingStatus: null,
      },
      selectedFilter: {
        fromDateToDate: true,
        branchID: true,
        taxType: true,
        fromNoToNo: true,
        nsDocID: true,
      },
      filterOptions: [
        { key: "fromDateToDate", label: "วันที่เอกสาร" },
        { key: "branchID", label: "สาขากิจการ" },
        { key: "taxType", label: "ประเภท ภ.ง.ด" },
        { key: "fromNoToNo", label: "เลขที่เอกสาร" },
        { key: "nsDocID", label: "เลขที่เอกสาร NS" },
      ],
      filterValueList:[
        "fromDateToDate",
        "branchID",
        "taxType",
        "fromNoToNo",
        "nsDocID",
      ],
      defaultFilterValueList: [
      ],
      
      companyID: this.$route.params.companyId,
      fromDateMenu: false,
      fromDateVal: null,
      minDate: "1990-01-05",
      maxDate: new Date(),
      toDateMenu: false,
      toDateVal: null,
      minDateToDate: this.fromDateVal,
      //check file
      // template import data
      selectedTemp: "template-1",
      temp1Hiden: false,
      template1: null,
      templateh: null,
      templatel: null,
      temp2Hiden: true,
      //end template import data
      selectedAll: false,
      emailDialog: false,
      taxRisDialog: false,
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      emailValid: false,
      taxRisValid: false,
      sendEmailLoading: false,
      isExportExcelLoading: false,
      sendEmailSuccessCount: 0,
      mEmailTemplateID: "Default Template",
      mEmailTemplatesListUnsubscribeObject: null,
      mEmailTemplatesList: [],
      mEmailTemplatesIDList: [],
      alert: {
        text: "",
        type: "success",
        show: false,
        showOnDialog: false,
      },

      pdfDialog: false,
      showModal: false, 
      modalID: "",
      pdfDownloadCount:  0,
      pdfPrintCount:  0,
      pdfSrc: "",
      downloadPdfLoading: false,
      clearingDownloadedXml: false,
      optionFilterList: [
        { label: "ดาวน์โหลดแล้ว", key: "@DownloadedXml" },
        { label: "ยังไม่ได้ดาวน์โหลด", key: "not-download" },
        { label: "เอกสารที่ยกเลิก", key: "cancelled" },
      ],
      defaultValueFilterList: ["@DownloadedXml", "not-download", "cancelled"],
      optionHideList: [
        { label: "แสดงทั้งหมด", key: "all" },
        { label: "ประเภทเอกสาร", key: "paymentType" },
        { label: "เลขที่เอกสาร WHT", key: "documentID" },
        { label: "วันที่ WHT", key: "docDate" },
        { label: "ชื่อผู้ถูกหัก", key: "payeeName" },
        { label: "เลขประจำตัวผู้ถูกหักภาษี", key: "payeeTaxId" },
        {
          label: "สาขาผู้ถูกหัก",
          key: "entityBranch",
        },
        { label: "มูลค่าฐานภาษี", key: "taxWHSumBaseAmount" },
        { label: "มูลค่าภาษีที่หัก", key: "taxWHSumAmount" },
        { label: "ที่อยู่", key: "payeeAddress" },
        { label: "ลิงก์", key: "link" },
      ],
      valueHideList: [
        "all",
        "paymentType",
        "documentID",
        "docDate",
        "payeeName",
        "payeeTaxId",
        "entityBranch",
        "taxWHSumBaseAmount",
        "taxWHSumAmount",
        "payeeAddress",
        "link",
      ],
      defaultValueHideList: [
        "all",
        "paymentType",
        "documentID",
        "docDate",
        "payeeName",
        "payeeTaxId",
        "entityBranch",
        "taxWHSumBaseAmount",
        "taxWHSumAmount",
        "payeeAddress",
        "link",
      ],
      searchOptionList: [
        { label: "ประเภทเอกสาร", key: "paymentType" },
        { label: "เลขที่เอกสาร WHT", key: "documentID" },
        { label: "วันที่ WHT", key: "docDate" },
        { label: "ชื่อผู้ถูกหัก", key: "payeeName" },
        { label: "เลขประจำตัวผู้ถูกหักภาษี", key: "payeeTaxId" },

        //{ label: "เวลาลงลายมือชื่อ", key: "@TimeSignedXml" },
      ],
      payeeTypeOptions: [
        { key: "J", value: "Journal" },
        { key: "B", value: "Bill Payment" },
      ],
      defaultSearchOptionValue: "documentID",
      disablePopOver: false,
      mouse: false,
      dragging: false,
      height: 0,
      resize: false,
      //filter
      filter: {
        issueDateTimeRange: [],
        objectId: "",
        scttAhtaBtpId: "",
        buyerBranchId: "",

        typeLineTotal: "",
        lineTotal: [],

        typeTaxTotal: "",
        taxTotal: [],

        typeGrandTotal: "",
        grandTotal: [],

        timeSignedXmlRange: [],
        docType: "",
        status: {
          downloadedXml: null,
          signSuccess: null,
          missingInfo: null,
          mailSent: null,
          suspendedAccount: null,
          buyerEmail_Isnull: null,
        },
      },

      // pagination
      pageInfo: null,
      totalCount: 0,
      edgeCount: 0,
      page: 1,
      itemsPerPage:
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"), // hardcode for auto case
      first:
        localStorage.getItem("pageLimit") === "auto"
          ? "10"
          : localStorage.getItem("pageLimit"),
      after: null,
      last: null,
      before: null,
      hasNextPage: null,
      hasPreviousPage: null,
      startCursor: null,
      endCursor: null,
      showPagination: false,

      // gql
      skipQuery: true,

      // email
      emailList: {},
      taxRisList: [],
      emailInput: "",
      awaitingDrag: false,
      timer: false,
      sentEmailHover: false,
      sentTaxRisHover: false,
      // export
      menuDatePickerStart: false,
      menuDatePickerEnd: false,
      exportDialog: false,
      dateExportStart: "",
      dateExportEnd: "",

      // monthly pdf
      monthlyDownloadDialog: false,
      exportEmailStatusRadios: "All",
      importDialog: false,
      importFile: [],
      importFileTemp2: [],
      importFileTemp2Head: [],
      importFileTemp2Line: [],
      
      // 
      branchList: [],
      headerTitle: "",
      fillingStatus: [],
      cancelDocDialog: false,
      isCancellingTransaction: false,
      snackBarError: false,
      snackBarSuccess: false,
      snackBarMsg: "",
      resetPdfLoading: {},
      resetPdfDialog: false,
      resetPdfTarget: null,
      resetPdfClearSignature: false,
    };
  },
  mounted() {
    this.setTransactionStatus(this);
    this.getFillingStatus();
  },
  async created() {
    let resizeId;
    window.addEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.handleResize, 100);
    });
    this.handleResize();
    this.loadEmailTemplateList();
    this.$store.dispatch("thaismartTax/fetchTaxWHBranch", {companyId: this.companyID});
  },
  beforeDestroy() {
    this.$store.dispatch("thaismartTax/getDocListUnsubscribe");
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    isTableLoading() {
      // Mirror table.tax.vue: show the inline spinner only during a healthy
      // initial fetch. ConnectionBanner / network popup take over when the
      // backend or network is degraded.
      const ch = this.$store.state.connectionHealth || {};
      return (
        ch.pendingFirstSnapshots > 0 &&
        ch.backend === "healthy" &&
        ch.network === "online"
      );
    },
    ...mapState({
      docs: (state) => state.thaismartTax.list,
      loading: (state) => state.thaismartTax.loading,
      keyword: (state) => state.thaismartTax.keyword,
      downloaded: (state) => state.docsDownloaded.downloaded,
      downloadingXml: (state) => state.docsDownloaded.downloadingXml,
      downloadingPdf: (state) => state.docsDownloaded.downloadingPdf,
      downloadStatus: (state) => state.docsDownloaded.downloadStatus,
      selectedBranch: (state) => state.companies.selectedBranch,
      orderBySelect: (state) => state.thaismartTax.orderBySelect,
      valueFilterList: (state) => state.thaismartTax.valueFilterList,
      selectedList: (state) => state.thaismartTax.selectedList,
      showPaginationTemplate: (state) =>
        state.thaismartTax.showPaginationTemplate,
      companyStatus: (state) => state.statusesByCompany.companyStatus,
      globalLoading: (state) => state.loading.globalLoading,
      // summaryAll: (state) => state.docs.summaryAll,
      taxWHBranch: (state) => state.thaismartTax.taxWHBranch,
      transactionStatus: (state) => state.thaismartTax.transactionStatus,
      userCompany: (state) => state.user.userCompany,
      user: (state) => state.user.userData,
    }),
    // ปุ่ม "ยกเลิกรายการ" เปลี่ยนสถานะเอกสารของลูกค้าเป็น Cancel จึงสงวนไว้ให้
    // ทีมงาน Sala Daeng เท่านั้น ไม่ผูกกับ role ฝั่งบริษัทลูกค้า (isAdmin)
    canCancelTransaction() {
      return isSalaDaengEmail(this.user?.email);
    },
    fromDateDisp() {
      return this.fromDateVal;
      // format/do something with date
    },
    toDateDisp() {
      return this.toDateVal;
      // format/do something with date
    },
    
    minToDate() {
      // Calculate the minimum date (fromDateDisp + 1 day)
      const minDate = new Date(this.fromDateDisp);
      minDate.setDate(minDate.getDate());
      return minDate.toISOString().substr(0, 10);
    },
  },

  watch: {
    defaultSearchOptionValue: {
      handler: function () {
        this.$store.dispatch("thaismartTax/setFromDate", "");
        this.$store.dispatch("thaismartTax/setToDate", "");
        this.$store.dispatch("thaismartTax/updateKeyword", "");
        this.clearValue();
        this.clearSelectList();
        this.fromDateVal = null;
        this.toDateVal = null;
        this.query();
      },
    },
    selectedBranch: {
      handler: function () {
        this.query();
      },
    },
    fromDateVal: {
      handler: function (val) {
        this.filterData.fromDate = this.fromDateVal;
        if (!val) {
          this.toDateVal = null;
        }
      },
    },
    toDateVal: {
      handler: function () {
        this.filterData.toDate = this.toDateVal;
      },
    },
    selectedFilter: {
      handler: function (val) {
        if (!val.fromDateToDate) {
          this.filterData.fromDate = "";
          this.filterData.toDate = "";
        } else if (!val.branchID) {
          this.filterData.branchID = "";
        } else if (!val.taxType) {
          this.filterData.taxType = "";
        } else if (!val.fromNoToNo) {
          this.filterData.fromNo = "";
          this.filterData.toNo = "";
        } else if (!val.nsDocID) {
          this.filterData.nsDocID = "";
        }
        this.query()
      },
      deep: true,
    },
    $route() {
      this.clearValue();
      this.setTransactionStatus(this);
      this.query();
    },
    valueFilterList: {
      handler: function () {
        this.query();
      },
    },
    selectedList: {
      handler: function () {
        this.checkSelectedAll();
      },
    },
    docs: {
      handler: function () {
        this.checkSelectedAll();
      },
    },
    height: {
      handler: function () {
        this.matchHeight();
      },
    },
    taxWHBranch: {
      handler: function () {
        const obj = this.taxWHBranch.branch || [];
        this.branchList = obj.map((item) => {
          return item.code;
        });
      },
    },
  },

  methods: {
    getFirestoreDocUrl(docId) {
      const companyId = this.$route.params.companyId;
      return `https://console.firebase.google.com/project/sld-etax/firestore/databases/-default-/data/~2FCompanies~2F${companyId}~2FDocsThaiSmartTax~2F${docId}`;
    },
    // Engineer/developer action: clear cached PDF references so the
    // onWriteCompaniesDocsThaiSmartTax trigger regenerates a fresh PDF
    // using current code + template. Does NOT touch the doc's signature —
    // clearing those would force the user to re-sign.
    onClickResetPdf(doc) {
      this.resetPdfTarget = doc;
      this.resetPdfClearSignature = false; // reset to safe default each open
      this.resetPdfDialog = true;
    },
    cancelResetPdf() {
      // Lock close while an in-flight reset is happening so the loading
      // spinner can finish + snackbar can fire.
      if (this.resetPdfTarget && this.resetPdfLoading[this.resetPdfTarget.id]) return;
      this.resetPdfDialog = false;
      this.resetPdfTarget = null;
      this.resetPdfClearSignature = false;
    },
    async confirmResetPdf() {
      const doc = this.resetPdfTarget;
      if (!doc) return;
      const businessId = doc.documentID || doc.docID || doc.id;
      const clearSig = this.resetPdfClearSignature;
      this.$set(this.resetPdfLoading, doc.id, true);
      try {
        const payload = {
          "@PdfUrl": "",
          "@PdfPath": "",
        };
        if (clearSig) {
          // Dotted paths target nested fields without overwriting the
          // whole `signature` map (keeps any future sibling keys intact).
          payload["signature.name"] = "";
          payload["signature.signature_url"] = "";
          payload["signature.signature_base64"] = "";
        }
        await fc.db
          .doc(`Companies/${this.companyID}/DocsThaiSmartTax/${doc.id}`)
          .update(payload);
        this.snackBarMsg = `สั่งสร้าง PDF ใหม่ของ ${businessId} เรียบร้อย${clearSig ? ' (ล้างลายเซ็นด้วย)' : ''}`;
        this.snackBarSuccess = true;
        this.resetPdfDialog = false;
        this.resetPdfTarget = null;
        this.resetPdfClearSignature = false;
      } catch (err) {
        console.error("Reset PDF failed:", err);
        this.snackBarMsg = `สร้าง PDF ใหม่ไม่สำเร็จ: ${err.message || err}`;
        this.snackBarError = true;
        // leave dialog open so the user can retry
      } finally {
        this.$set(this.resetPdfLoading, doc.id, false);
      }
    },
    updatePdfDownloadCount(newCount) {
      //console.log(newCount)
      this.pdfDownloadCount = newCount;
    },
    getPrintCount(doc) {
      return doc?.['@PrintedPdfCount'] ?? 0;
    },
    getDownloadCount(doc) {
      return doc?.['@DownloadedPdfCount'] ?? 0;
    },
    formatCount(count) {
      if (!count || count <= 0) return '0';
      return count.toString();
    },
    async exportExcel() {
      this.isExportExcelLoading = true;
      try {
        // Filter data to only include items with a valid docID
        const filteredData = this.selectedList.filter((x) => x.docID);
        if (filteredData.length === 0) {
          throw new Error("No valid documents to export.");
        }

        const headerMapping = {
          "Creation Time": "timeCreated",
          "Base Amount": "taxWHSumBaseAmount",
          "Document Number": "internalDocument",
          Address: "payeeAddress",
          Branch: "entityBranch",
          "Document Date": "docDate",
          "Tax ID": "payeeTaxId",
          ID: "documentID",
          "Payment Type": "paymentType",
          Items: "items",
          "Amount Text": "taxWHSumAmountText",
          "Transaction Type": "transactionType",
          Amount: "taxWHSumAmount",
          Code: "taxWHCode",
          Condition: "taxWHCondition",
          "Payee Name": "payeeName",
          "Unique ID": "id",
        };
        const paymentTypeMapping = {
          B: "Bill Payment",
          J: "Journal",
        };

        const headers = Object.keys(headerMapping);
        const formatData = filteredData.map((item) => {
          const row = headers.reduce((acc, header) => {
            const dataField = headerMapping[header];
            const value = item.data ? item.data[dataField] : "";

            if (dataField === "timeCreated" || dataField === "docDate") {
              acc[header] = value ? this.formatDate(value) : "";
            } else if (dataField === "items") {
              acc[header] = Array.isArray(value)
                ? value.map((v) => JSON.stringify(v)).join("; ")
                : "";
            } else if (dataField === "paymentType") {
              acc[header] = paymentTypeMapping[value] || value;
            } else {
              acc[header] = value || "";
            }
            return acc;
          }, {});

          return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(formatData, {
          header: headers,
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const fileName = `NSThaiSmartTax_${new Date()
          .toISOString()
          .slice(0, 10)}.xlsx`;
        XLSX.writeFile(workbook, fileName);

        // Reset selected list
        this.clearSelectList();
      } catch (error) {
        console.error("Export failed:", error.message);
        //alert('Failed to export data. Please try again.');
      } finally {
        this.isExportExcelLoading = false;
      }
    },
    loadEmailTemplateList() {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        if (this.mEmailTemplatesListUnsubscribeObject) {
          this.mEmailTemplatesListUnsubscribeObject();
        }
        this.mEmailTemplatesListUnsubscribeObject = fc.db
          .collection(`Companies/${companyId}/EmailTemplates`)
          .onSnapshot((docs) => {
            this.mEmailTemplatesList = [];
            this.mEmailTemplatesIDList = ["Default Template"];

            docs.forEach((doc) => {
              const data = doc.data();
              data.id = doc.id;
              this.mEmailTemplatesList.push(data);
              this.mEmailTemplatesIDList.push(data.id);
            });
            // console.log(this.mEmailTemplatesList)
          });
      }
    },
    startDrag() {
      this.timer = false;
      this.dragging = false;
      this.mouse = true;
    },
    stopDrag(doc) {
      if (!this.dragging && this.mouse) {
        // this.onClickDocId(doc['@SignedPdfUrl'])
        this.onClickDocId(doc);
      }
      this.dragging = false;
      this.mouse = false;
    },
    doDrag() {
      if (this.mouse && !this.awaitingDrag) {
        this.timer = setTimeout(() => {
          this.dragging = true;
          this.awaitingDrag = false;
        }, 200);
        this.awaitingDrag = true;
      }
    },
    matchHeight() {
      if (localStorage.getItem("pageLimit") !== "auto") return;
      let cardTitle = document.getElementById("card-title")?.clientHeight || 0;
      let headerTable =
        document.getElementById("header-table")?.clientHeight || 0;
      let rowDetailRow = Math.floor(
        (this.height - (150 + cardTitle + headerTable)) / 67
      );
      let pageLimit = 10;
      pageLimit =
        rowDetailRow > 1
          ? rowDetailRow - 1
          : rowDetailRow >= 0
          ? rowDetailRow
          : 1;

      localStorage.setItem("pageLimitAuto", pageLimit.toString());
      this.$store.dispatch("user/setPageLimitAutoChange");
      this.clearValue();
      this.query();
    },
    handleResize() {
      this.height = window.innerHeight;
    },
    getTaxId: function (taxID, companyID) {
      if (!taxID || taxID == "N/A")
        return companyID == "XMigdx2tCoT0CD4JDkGN" ||
          companyID == "0m2cwidBErAKMf2I9vkT"
          ? ""
          : "N/A";
      let taxIDShow = "-";
      if (taxID.length > 13) {
        taxIDShow = taxID.substring(0, 13);
      } else if (taxID.length <= 13) {
        taxIDShow = taxID;
      }
      return taxIDShow;
    },
    getCheckedSelect: function (docID) {
      return this.selectedList.some((x) => x["docID"] === docID);
    },
    getFormatAmount(amount) {
      return formatTwoDecimal(amount);
    },
    getFormatToNumber(strr) {
      return Number(strr) || 0;
    },
    timeFormat: function (timestamp) {
      if (timestamp) {
        return moment(timestamp.toDate())
          .add(543, "years")
          .format("Do MMM YY, LTS");
      }
      return "-";
    },
    query: function () {
      this.$store.dispatch("thaismartTax/setFilterData", {
        ...this.filterData,
      });
      let companyId = this.$route.params.companyId;

      if (companyId) {
        this.$store.dispatch("thaismartTax/getList", {
          id: companyId,
          selectedBranch: this.selectedBranch,
        });
      }
    },
    getEmailList: function () {
      for (let e of this.selectedList) {
        if (e.docID) {
          if (!this.emailList[e.docID]) {
            this.emailList[e.docID] = [];
          }
          if (e.buyerEmail) {
            this.emailList[e.docID] = Vue.observable(
              e.buyerEmail.replaceAll(";", ",").split(",")
            );
          } else {
            this.emailList[e.docID] = Vue.observable([]);
          }
        }
      }
    },

    clearEmailList: function () {
      this.emailDialog = false;
      this.emailList = {};
    },

    getDocumentType() {
      let documentType = router.currentRoute.name.split(".");
      if (documentType.length > 2) {
        return documentType[documentType.length - 1];
      }
      return "";
    },
    getDocsByRange(timeStart, timeEnd) {
      const companyID = this.$route.params.companyId;
      let documentType = this.getDocumentType();
      // console.log("documentType:: ", documentType);
      let documentTypeNumber = getDocumentTypeKey(documentType);
      // console.log(documentType, documentTypeNumber);

      let q = fc.db.collection(`Companies/${companyID}/Docs`);
      if (documentTypeNumber) {
        q = q.where("@DocType", "==", documentTypeNumber);
      }
      q = q.where(
        new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp"),
        ">=",
        timeStart.toDate()
      );
      q = q.where(
        new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp"),
        "<",
        timeEnd.toDate()
      );
      q = q.orderBy(
        new firebase.firestore.FieldPath("ED.IssueDateTime.Timestamp")
      );
      return q.get();
    },
    exportDocs() {
      const timeStart = moment(this.dateExportStart + "T00:00:00.000+07:00");
      const timeEnd = moment(this.dateExportEnd + "T00:00:00.000+07:00").add(
        1,
        "days"
      );
      const filterEmailStatus = this.exportEmailStatusRadios;
      this.getDocsByRange(timeStart, timeEnd).then((querySnapshot) => {
        const rows = [
          [
            "วันที่เอกสาร", // ED.IssueDateTime
            "เลขที่เอกสาร", // objectID
            "รหัสผู้ซื้อ", // SCTT.AHTA.BTP.ID
            "ชื่อผู้ซื้อ/ชื่อบริษัท", // SCTT.AHTA.BTP.Name
            "เลขผู้เสียภาษี", // SCTT.AHTA.BTP.STR.ID
            "สาขาผู้ซื้อ", // @BuyerBranchID
            "มูลค่าที่นำมาคิดภาษี", // SCTT.AHTS.STSHMS.TaxBasisTotalAmount
            "ภาษีมูลค่าเพิ่ม", // SCTT.AHTS.STSHMS.TaxTotalAmount
            "ยอดรวม", // SCTT.AHTS.STSHMS.GrandTotalAmount
            "สถานะการส่งอีเมล", // @MailSent
            "เวลาการส่งอีเมล", // @TimeMailSent
          ],
        ];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          // console.log(data);

          // filter by send email status
          if (filterEmailStatus !== "All") {
            if (
              (filterEmailStatus === "Sent" && !data["@MailSent"]) ||
              (filterEmailStatus === "NotSent" && data["@MailSent"])
            ) {
              return;
            }
          }

          rows.push([
            data["ED.IssueDateTime"].split("T")[0],
            data["objectID"],
            data["SCTT.AHTA.BTP.ID"],
            data["SCTT.AHTA.BTP.Name"],
            this.getTaxId(data["SCTT.AHTA.BTP.STR.ID"]),
            data["@BuyerBranchID"],
            libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"]),
            libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.TaxTotalAmount"]),
            libCSV.stangToTHB(data["SCTT.AHTS.STSHMS.GrandTotalAmount"]),
            data["@MailSent"] ? "Y" : "N",
            data["@TimeMailSent"]
              ? moment(data["@TimeMailSent"].toDate()).format(
                  "YYYY-MM-DDTHH:mm:ss"
                )
              : "",
          ]);
        });
        libCSV.exportCSV(
          `Docs_${this.dateExportStart}_${this.dateExportEnd}.csv`,
          rows
        );
        this.exportDialog = false;
      });
    },
    cancelExportDialog() {
      this.exportDialog = false;
    },

    handleImportFile(e) {
      if (e.type != "text/csv") {
        this.alert = {
          text: "ไมสามารถอ่านข้อมูลได้ กรุณาเลือกไฟล์ CSV",
          type: "error",
          show: true,
          showOnDialog: true,
        };
        this.$refs.importFileRef.reset();
      } else {
        if (e) {
          Papa.parse(e, {
            header: false,
            skipEmptyLines: true,
            complete: function (results) {
              this.importFile = results;
              // this.parsed = true;
            }.bind(this),
          });
        }
      }
    },
    // handleImportFileTemp2
    handleImportFileTemp2(type, e) {
      // check type file
      if (e.type != "text/csv") {
        this.alert = {
          text: "ไมสามารถอ่านข้อมูลได้ กรุณาเลือกไฟล์ CSV",
          type: "error",
          show: true,
        };

        this.$refs.importFileRefH.reset();
        this.$refs.importFileRefL.reset();
        // this.alertFile = true;
        // console.log("Hey!! get out"+e.type)
      } else {
        switch (type) {
          case "head":
            if (e) {
              Papa.parse(e, {
                header: false,
                skipEmptyLines: true,
                complete: function (results) {
                  this.importFileTemp2Head = results;
                  // this.parsed = true;
                }.bind(this),
              });
            }
            break;
          case "line":
            if (e) {
              Papa.parse(e, {
                header: false,
                skipEmptyLines: true,
                complete: function (results) {
                  this.importFileTemp2Line = results;
                }.bind(this),
              });
            }
            break;
        }
      }
    },
    async importDocs() {
      let csvData = [];
      var ret = [];
      try {
        switch (this.selectedTemp) {
          case "template-1":
            if (
              this.importFile.data < 0 ||
              typeof this.importFile.data === "undefined" ||
              this.importFile.data == 0 ||
              this.importFile.data == null
            ) {
              this.alert = {
                text: "กรุณาเลือกไฟล์ CSV",
                type: "error",
                show: true,
              };
            }

            for (var i = 1; i < this.importFile.data.length; i++) {
              var temp = this.importFile.data[i];
              var obj = {
                docType: temp[0],
                sellerName: temp[1],
                sellerAddress: temp[2],
                sellerTaxID: temp[3],
                sellerBranchID: temp[4],
                buyerID: temp[5],
                buyerName: temp[6],
                buyerTaxID: temp[7],
                buyerAddress: temp[8],
                buyerBranchID: temp[9],
                buyerEmail: temp[10],
                buyerOrderRefDoc: temp[11],
                issuerAssignedID: temp[12],
                FissueDate: temp[13],
                typeCode: temp[14],
                docID: temp[15],
                issueDate: temp[16],
                creationDate: temp[17],
                noteSubject: temp[18],
                reference: temp[19],
                additionalRefDocs: temp[20],
                LissuerAssignedID: temp[21],
                LissueDate: temp[22],
                LtypeCode: temp[23],
                currency: temp[24],
                vat: temp[25],
                line: temp[26],
                discount: temp[27],
                basis: temp[28],
                tax: temp[29],
                total: temp[30],
                originalinformationamount: temp[31],
                differenceInformationAmount: temp[32],
                purposeCode: temp[33],
                purpose: temp[34],
                items: temp[35],
                productID: temp[36],
                description: temp[37],
                price: temp[38],
                unit: temp[39],
                quantity: temp[40],
                Lvat: temp[41],
                Ldiscount: temp[42],
                Lbasis: temp[43],
                Ltax: temp[44],
                Ltotal: temp[45],
                baseInvoiceAmount: temp[46],
                docDueDate: temp[47],
                paymentTermsCode: temp[48],
                customerVendorRef: temp[49],
                downPaymentAmount: temp[50],
                tel1: temp[51],
                tel2: temp[52],
                fax1: temp[53],
                salesEmployeeName: temp[54],
                contactPersonName: temp[55],
                baseRefNo: temp[56],
                baseRefDate: temp[57],
                crReason1: temp[58],
                crReason2: temp[59],
                drReason1: temp[60],
                drReason2: temp[61],
                payBy: temp[62],
                domain: temp[63],
                allowancePercent: temp[64],
              };
              csvData.push(obj);
            }
            var tempCustomer = {};
            for (i = 0; i < csvData.length; i++) {
              var item = csvData[i];
              if (item.sellerName) {
                if (i > 0) {
                  ret.push(tempCustomer);
                }
                tempCustomer = item;
                tempCustomer.items = [];
              } else {
                tempCustomer.items.push(item);
              }
            }

            if (tempCustomer) {
              ret.push(tempCustomer);
            }
            break;
          case "template-2":
            var arrHead = [];
            var arrLine = [];
            if (
              this.importFileTemp2Head.data < 0 ||
              typeof this.importFileTemp2Head.data === "undefined" ||
              this.importFileTemp2Head.data == 0 ||
              this.importFileTemp2Head.data == null
            ) {
              this.alert = {
                text: "กรุณาเลือกไฟล์ CSV ส่วนหัว",
                type: "error",
                show: true,
              };
            } else if (
              this.importFileTemp2Line.data < 0 ||
              typeof this.importFileTemp2Line.data === "undefined" ||
              this.importFileTemp2Line.data == 0 ||
              this.importFileTemp2Line.data == null
            ) {
              this.alert = {
                text: "กรุณาเลือกไฟล์ CSV ส่วนเนื้อใน",
                type: "error",
                show: true,
              };
            }
            // if (this.importFileTemp2Line.data < 0 || typeof this.importFileTemp2Line.data === 'undefined' || this.importFileTemp2Line.data == 0 || this.importFileTemp2Line.data == null) {
            //   this.alert2 = {
            //     text: "กรุณาเลือกไฟล์ CSV ส่วนเนื้อใน",
            //     type: "error",
            //     show: true
            //   };
            // }
            for (i = 1; i < this.importFileTemp2Head.data.length; i++) {
              var tempHead = this.importFileTemp2Head.data[i];
              var objHead = {
                docType: tempHead[0],
                sellerName: tempHead[1],
                sellerAddress: tempHead[2],
                sellerTaxID: tempHead[3],
                sellerBranchID: tempHead[4],
                buyerID: tempHead[5],
                buyerName: tempHead[6],
                buyerTaxID: tempHead[7],
                buyerAddress: tempHead[8],
                buyerBranchID: tempHead[9],
                buyerEmail: tempHead[10],
                buyerOrderRefDoc: tempHead[11],
                issuerAssignedID: tempHead[12],
                FissueDate: tempHead[13],
                typeCode: tempHead[14],
                docID: tempHead[15],
                issueDate: tempHead[16],
                creationDate: tempHead[17],
                noteSubject: tempHead[18],
                reference: tempHead[19],
                additionalRefDocs: tempHead[20],
                LissuerAssignedID: tempHead[21],
                LissueDate: tempHead[22],
                LtypeCode: tempHead[23],
                currency: tempHead[24],
                vat: tempHead[25],
                line: tempHead[26],
                discount: tempHead[27],
                basis: tempHead[28],
                tax: tempHead[29],
                total: tempHead[30],
                originalinformationamount: tempHead[31],
                differenceInformationAmount: tempHead[32],
                purposeCode: tempHead[33],
                purpose: tempHead[34],
                //line
                items: "",
                productID: "",
                description: "",
                price: "",
                unit: "",
                quantity: "",
                Lvat: "",
                Ldiscount: "",
                Lbasis: "",
                Ltax: "",
                Ltotal: "",
                //
                baseInvoiceAmount: tempHead[35],
                docDueDate: tempHead[36],
                paymentTermsCode: tempHead[37],
                customerVendorRef: tempHead[38],
                downPaymentAmount: tempHead[39],
                tel1: tempHead[40],
                tel2: tempHead[41],
                fax1: tempHead[42],
                salesEmployeeName: tempHead[43],
                contactPersonName: tempHead[44],
                baseRefNo: tempHead[45],
                baseRefDate: tempHead[46],
                crReason1: tempHead[47],
                crReason2: tempHead[48],
                drReason1: tempHead[49],
                drReason2: tempHead[50],
                payBy: tempHead[51],
                domain: tempHead[52],
                allowancePercent: temp[64],
              };
              arrHead.push(objHead);
            }

            for (i = 1; i < this.importFileTemp2Line.data.length; i++) {
              var tempLine = this.importFileTemp2Line.data[i];
              var objLine = {
                docType: "",
                sellerName: "",
                sellerAddress: "",
                sellerTaxID: "",
                sellerBranchID: "",
                buyerID: "",
                buyerName: "",
                buyerTaxID: "",
                buyerAddress: "",
                buyerBranchID: "",
                buyerEmail: "",
                buyerOrderRefDoc: "",
                issuerAssignedID: "",
                FissueDate: "",
                typeCode: "",
                docID: "",
                issueDate: "",
                creationDate: "",
                noteSubject: "",
                reference: "",
                additionalRefDocs: "",
                LissuerAssignedID: "",
                LissueDate: "",
                LtypeCode: "",
                currency: "",
                vat: "",
                line: "",
                discount: "",
                basis: "",
                tax: "",
                total: "",
                originalinformationamount: "",
                differenceInformationAmount: "",
                purposeCode: "",
                purpose: "",
                //line
                items: tempLine[1],
                productID: tempLine[2],
                description: tempLine[3],
                price: tempLine[4],
                unit: tempLine[5],
                quantity: tempLine[6],
                Lvat: tempLine[7],
                Ldiscount: tempLine[8],
                Lbasis: tempLine[9],
                Ltax: tempLine[10],
                Ltotal: tempLine[11],
                //
                baseInvoiceAmount: "",
                docDueDate: "",
                paymentTermsCode: "",
                customerVendorRef: "",
                downPaymentAmount: "",
                tel1: "",
                tel2: "",
                fax1: "",
                salesEmployeeName: "",
                contactPersonName: "",
                baseRefNo: "",
                baseRefDate: "",
                crReason1: "",
                crReason2: "",
                drReason1: "",
                drReason2: "",
                payBy: "",
                domain: "",
              };
              arrLine.push(objLine);
            }
            arrHead.forEach((listHead) => {
              var itemList = arrLine.filter(
                (arrLine) => arrLine.docID == listHead.docID
              );
              var obj2 = {
                docType: listHead.docType,
                sellerName: listHead.sellerName,
                sellerAddress: listHead.sellerAddress,
                sellerTaxID: listHead.sellerTaxID,
                sellerBranchID: listHead.sellerBranchID,
                buyerID: listHead.buyerID,
                buyerName: listHead.buyerName,
                buyerTaxID: listHead.buyerTaxID,
                buyerAddress: listHead.buyerAddress,
                buyerBranchID: listHead.buyerBranchID,
                buyerEmail: listHead.buyerEmail,
                buyerOrderRefDoc: listHead.buyerOrderRefDoc,
                issuerAssignedID: listHead.issuerAssignedID,
                FissueDate: listHead.FissueDate,
                typeCode: listHead.typeCode,
                docID: listHead.docID,
                issueDate: listHead.issueDate,
                creationDate: listHead.creationDate,
                noteSubject: listHead.noteSubject,
                reference: listHead.reference,
                additionalRefDocs: listHead.additionalRefDocs,
                LissuerAssignedID: listHead.LissuerAssignedID,
                LissueDate: listHead.LissueDate,
                LtypeCode: listHead.LtypeCode,
                currency: listHead.currency,
                vat: listHead.vat,
                line: listHead.line,
                discount: listHead.discount,
                basis: listHead.basis,
                tax: listHead.tax,
                total: listHead.total,
                originalinformationamount: listHead.originalinformationamount,
                differenceInformationAmount:
                  listHead.differenceInformationAmount,
                purposeCode: listHead.purposeCode,
                purpose: listHead.purpose,
                //line
                items: itemList,
                productID: "",
                description: "",
                price: "",
                unit: "",
                quantity: "",
                Lvat: "",
                Ldiscount: "",
                Lbasis: "",
                Ltax: "",
                Ltotal: "",
                //
                baseInvoiceAmount: listHead.baseInvoiceAmount,
                docDueDate: listHead.docDueDate,
                paymentTermsCode: listHead.paymentTermsCode,
                customerVendorRef: listHead.customerVendorRef,
                downPaymentAmount: listHead.downPaymentAmount,
                tel1: listHead.tel1,
                tel2: listHead.tel2,
                fax1: listHead.fax1,
                salesEmployeeName: listHead.salesEmployeeName,
                contactPersonName: listHead.contactPersonName,
                baseRefNo: listHead.baseRefNo,
                baseRefDate: listHead.baseRefDate,
                crReason1: listHead.crReason1,
                crReason2: listHead.crReason2,
                drReason1: listHead.drReason1,
                drReason2: listHead.drReason2,
                payBy: listHead.payBy,
                domain: listHead.domain,
              };
              ret.push(obj2);
            });
            break;
        }
        if (ret.length > 0) {
          let companyID = this.$route.params.companyId;
          await this.$store.dispatch("importDocs/importDocs", {
            docs: ret,
            companyID,
          });
          this.alert = {
            text: "นำเข้าข้อมูล สําเร็จ หน้าเว็บจะรีโหลดในอีก 3 วิ",
            type: "success",
            show: true,
            showOnDialog: true,
          };
          // setTimeout(()=> this.cancelImportDialog(),1000);
          setTimeout(() => window.location.reload(), 3000);
        }
      } catch (error) {
        console.log("File import error " + error.toString());
        this.alert = {
          text: "นำเข้าข้อมูล ไม่สําเร็จ",
          type: "error",
          show: true,
          showOnDialog: true,
        };
      }
    },
    cancelImportDialog() {
      this.importDialog = false;
      this.importFile = [];
      this.template1 = null;
      this.templateh = null;
      this.templatel = null;
      this.alert = {
        text: "",
        type: "success",
        show: false,
        showOnDialog: false,
      };
      //this.$refs.importFileRef.value=null
    },
    clickSelectedAll: function (checked) {
      let selectedList = _.cloneDeep(this.selectedList);
      if (checked) {
        thaismartTax.state.list.forEach((doc) => {
          if (!selectedList.some((x) => x["docID"] === doc.id)) {
            selectedList.push({
              companyID: this.companyID,
              docID: doc.id,
              data: doc,
              pdfUrl: doc["@SignedPdfUrl"],
              xmlUrl: doc["@SignedXmlUrl"],
            });
            //console.log("selectedList",selectedList)
          }
        });
      } else {
        thaismartTax.state.list.forEach((doc) => {
          let index = selectedList.findIndex((x) => x["docID"] === doc.id);
          if (index !== -1) {
            selectedList.splice(index, 1);
          }
        });
      }
      this.$store.dispatch("thaismartTax/setSelectedList", {
        selectedList: selectedList,
      });
    },
    clickSelected: function (doc) {
      let valueList = _.cloneDeep(this.selectedList);
      if (this.getCheckedSelect(doc.id)) {
        let index = valueList.findIndex((x) => x["docID"] === doc.id);
        valueList.splice(index, 1);
      } else {
        valueList.push({
          companyID: this.companyID,
          docID: doc.id,
          data: doc,
          pdfUrl: doc["@SignedPdfUrl"],
          xmlUrl: doc["@SignedXmlUrl"],
        });
      }
      //console.log(valueList)
      this.$store.dispatch("thaismartTax/setSelectedList", {
        selectedList: valueList,
      });
    },
    checkSelectedAll: function () {
      let selectedAll = false;
      let checkCount = 0;
      this.selectedList.forEach((select) => {
        if (thaismartTax.state.list.some((doc) => doc.id === select.docID)) {
          checkCount++;
        }
      });
      if (
        checkCount === thaismartTax.state.list.length &&
        thaismartTax.state.list.length > 0
      ) {
        selectedAll = true;
      }
      this.selectedAll = selectedAll;
    },
    debounceInput: _.debounce(function (keyword) {
      this.changeKeyword(keyword);
    }, 800),
    changeKeyword: function (keyword) {
      this.clearValue();
      let companyId = this.$route.params.companyId;

      if (companyId) {
        // this.$store.dispatch("thaismartTax/updateKeyword", {
        //   id: companyId,
        //   keyword: keyword,
        // });
        this.filterData.payeeName = keyword;
        this.onChangeValueSearchOption(this.filterData);
        let resizeId;
        window.addEventListener("resize", () => {
          clearTimeout(resizeId);
          resizeId = setTimeout(this.handleResize, 100);
        });
        this.handleResize();
      }
    },
    validateEmail: function () {
      if (this.$refs.form.validate()) {
        this.emailDialog = false;
        this.sendEmail();
      }
    },
    sendEmail: async function () {
      this.sendEmailLoading = true;

      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      // let allEmailFill = (this.emailList.join(',').replaceAll(';',',')).split(",")
      // let allEmailSelected = (this.selectedList.map(select => {
      //   return select['buyerEmail'].replaceAll(';',',')
      // }))
      // allEmailSelected = (allEmailSelected.join(',')).split(',')
      // let emailWouldSend = []
      // for(let e of allEmailFill) {
      //   if(!allEmailSelected.includes(e)){
      //     emailWouldSend.push(e)
      //   }
      // }
      // const promises = this.selectedList.map(async (select) => {
      //   let allEmailSend = select['buyerEmail'].replaceAll(';',',')
      //   if(emailWouldSend.length>0){
      //     if(allEmailSend) {
      //       allEmailSend += ',' + emailWouldSend.join(',')
      //     }else{
      //       allEmailSend = emailWouldSend.join(',')
      //     }
      //   }
      //   let data = {
      //     company_id: this.$route.params.companyId,
      //     invoice_id: select['docID'],
      //     email: allEmailSend,
      //   }

      //   await axios.post(fc.cloudFunctionUrl + "sendemail", data, {headers})
      //     .then((response) => {
      //       if (response.status === 200) {
      //         this.sendEmailSuccessCount++
      //       }

      //     }, (error) => {
      //       console.log(error)
      //     });
      // })
      const promises = Object.keys(this.emailList).map(async (k) => {
        let data = {
          company_id: this.$route.params.companyId,
          invoice_id: k,
          email: this.emailList[k].join(","),
        };

        if (this.mEmailTemplateID != "Default Template") {
          data["emailTemplateID"] = this.mEmailTemplateID;
        }

        await axios
          .post(fc.cloudFunctionUrl + "sendemail", data, { headers })
          .then(
            (response) => {
              if (response.status === 200) {
                this.sendEmailSuccessCount++;
              }
            },
            (error) => {
              console.log(error);
            }
          );
      });

      await Promise.all(promises);
      if (this.sendEmailSuccessCount === this.selectedList.length) {
        this.alert = {
          text: "ส่งอีเมลสำเร็จ " + this.sendEmailSuccessCount + " รายการ",
          type: "success",
          show: true,
        };

        this.sendEmailSuccessCount = 0;

        this.query();
      }
      this.sendEmailLoading = false;
      this.emailDialog = false;
      this.email = "";
      this.emailList = {};
    },
    changeOrderBy: function (order) {
      let orderBySelect = _.cloneDeep(this.orderBySelect);
      if (!(this.orderBySelect["key"] === order)) {
        orderBySelect = { key: order, value: "asc" };
      } else {
        if (_.get(orderBySelect, "value") === "asc") {
          _.set(orderBySelect, "value", "desc");
        } else {
          orderBySelect = {};
        }
      }
      this.$store.dispatch("thaismartTax/setOrderBySelect", {
        orderBySelect: orderBySelect,
      });
      this.$store.dispatch("thaismartTax/updatePage", { page: 1 });
      this.query();
    },
    downloadPDF: function () {
      console.log("tst");
      return;
      // zipFiles(this.$route.params.companyId, this.selected, "pdf", '@SignedPdfUrl', this.$store.dispatch)
      // this.downloadZip("pdf", this.selectedList, "pdf", MAX_DOC_PER_ZIP["pdf"]);
    },
    downloadMonthly: async function ({ month, fileType, filter }) {
      let maxPerZip = MAX_DOC_PER_ZIP[fileType] || 0;

      try {
        this.loadingDownloadZip("monthly", "on");
        this.setDownloadProgress("monthly", "");
        const startDate = moment(month).startOf("day");
        const endDate = moment(month).endOf("month").endOf("day");
        const snapshot = await this.getDocsByRange(startDate, endDate);

        let selected = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          selected.push({
            docID: doc.id,
            pdfUrl: data["@SignedPdfUrl"],
            xmlUrl: data["@SignedXmlUrl"],
            downloadedXml: data["@DownloadedXml"],
          });
        });

        if (filter) {
          if (filter.downloadedXml === "Downloaded") {
            selected = selected.filter((doc) => doc.downloadedXml);
          } else if (filter.downloadedXml === "NotDownloaded") {
            selected = selected.filter((doc) => !doc.downloadedXml);
          }
        }

        await this.downloadZip(fileType, selected, "monthly", maxPerZip);
      } catch (err) {
        this.loadingDownloadZip("monthly", "off");
      }
    },
    downloadXML: function () {
      // zipFiles(this.$route.params.companyId, this.selected, "xml", '@SignedXmlUrl', this.$store.dispatch)
      this.downloadZip("xml", this.selectedList, "xml", MAX_DOC_PER_ZIP["xml"]);
    },
    loadingDownloadZip: function (type, onOff) {
      let boolean = onOff === "on";
      if (type === "xml")
        this.$store.dispatch("docsDownloaded/updateDownloadingXml", {
          downloadingXml: boolean,
        });
      else if (type === "pdf")
        this.$store.dispatch("docsDownloaded/updateDownloadingPdf", {
          downloadingPdf: boolean,
        });
      else
        this.$store.commit("docsDownloaded/setDownloading", {
          type: type,
          downloading: boolean,
        });
    },
    setDownloadProgress: function (type, progress) {
      this.$store.commit("docsDownloaded/setDownloadProgress", {
        type: type,
        progress: progress,
      });
    },
    downloadZip: async function (type, selected, loadingType, maxPerZip) {
      if (!loadingType) {
        loadingType = type;
      }

      this.loadingDownloadZip(loadingType, "on");
      let urlField = "pdfUrl";
      if (type === "xml") {
        urlField = "xmlUrl";
      }
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let docList = [];
      let timeStamp = new Date().getTime();

      // เอาเฉพาะแถวที่มี url
      selected.forEach((docSelect) => {
        if (docSelect[urlField]) {
          docList.push({ id: docSelect["docID"], url: docSelect[urlField] });
        }
      });

      if (docList.length === 0) {
        this.loadingDownloadZip(loadingType, "off");
        this.alert = {
          text: "ไม่พบเอกสารที่ต้องการ",
          type: "error",
          show: true,
        };
        return;
      }

      if (!maxPerZip) {
        maxPerZip = docList.length;
      }

      const companyId = this.$route.params.companyId;
      const zipChunk = async function (chunk, startNumber) {
        const result = await axios.post(
          fc.cloudFunctionUrl + "zipFiles",
          { data: chunk, type: type, companyID: companyId },
          { headers, responseType: "arraybuffer" }
        );
        if (result.data.byteLength !== 0) {
          let url = URL.createObjectURL(
            new Blob([result.data], { type: "application/zip" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${timeStamp}_${startNumber}-${startNumber + chunk.length - 1}.zip`
          );
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
        }
      };

      // split documents into smaller chunks
      // then zip and download each
      let startNumber = 1;
      const total = docList.length;
      while (docList.length > 0) {
        try {
          const chunk = docList.splice(0, maxPerZip);
          this.setDownloadProgress(
            loadingType,
            `กำลังโหลด...(${startNumber - 1}/${total})`
          );
          await zipChunk(chunk, startNumber);
          startNumber += chunk.length;
        } catch (err) {
          console.log("front end error: ", err);
          this.alert = {
            text: "เกิดข้อผิดพลาดขณะดาวน์โหลด กรุณาลองอีกครั้ง",
            type: "error",
            show: true,
          };
          this.loadingDownloadZip(loadingType, "off");
          return;
        }
      }

      this.loadingDownloadZip(loadingType, "off");
      this.clearSelectList();
    },
    clearDownloadedXml: async function () {
      this.clearingDownloadedXml = true;

      const companyID = this.$route.params.companyId;
      const list = this.selectedList.filter((doc) => doc.downloadedXml);
      const count = list.length;
      const batch = fc.db.batch();

      list.forEach((doc) => {
        const docRef = fc.db.doc(`Companies/${companyID}/Docs/${doc.docID}`);
        batch.update(docRef, {
          "@DownloadedXml": false,
        });
      });

      try {
        await batch.commit();
        this.alert = {
          text: "ยกเลิกค่าดาวน์โหลดสำเร็จ " + count + " รายการ",
          type: "success",
          show: true,
        };
      } catch (err) {
        console.error("clearDownloadedXml error: ", err);
        this.alert = {
          text: "เกิดข้อผิดพลาดขณะยกเลิกค่าดาวน์โหลด กรุณาลองอีกครั้ง",
          type: "error",
          show: true,
        };
      }

      this.clearSelectList();
      this.clearingDownloadedXml = false;
    },
    onClickDocId: async function (doc) {
      this.$store.dispatch("setGlobalLoading", true);
      // if(doc){
      //   return
      // }
      this.downloadPdfLoading = true;

      let pdfLink = doc["@PdfUrl"];
      // console.log("Doc Clicked, PDF LINK::  ", pdfLink);
      if (!pdfLink) {
        this.alert = {
          text: "ยังไม่ได้สร้าง Pdf ให้เอกสาร " + doc["documentID"],
          type: "error",
          show: true,
        };
      }

      let updatedPdfLink = doc["@UpdatedPdfUrl"];

      let link = "";

      if (!pdfLink && !updatedPdfLink) {
        //console.log('take from api')
        link = await this.updateThaiSmartTaxPdf(doc["documentID"]);
      } else if (pdfLink) {
        // console.log("take from field")
        link = pdfLink;
      } else if (updatedPdfLink) {
        link = updatedPdfLink;
      }

      console.log("linkk:: ", link);

      if (link) {
        await axios
          .get(link, {
            responseType: "arraybuffer",
          })
          .then(
            async (response) => {
              this.downloadPdfLoading = false;

              let url = URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
              );

              if (isMobile()) {
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;

                let newDownloadCount = doc["@DownloadedPdfCount"] ?? 0
                let docID = doc["documentID"]
                const data = { "pdfCount": newDownloadCount + 1 ,  "docID": docID , "type": 'download'};

     
                await this.updateDocument(data);

                a.download = "netsuite-thaismartTax-" + new Date().getTime() + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
              } else {
                this.pdfSrc = url;
                this.modalID = doc["documentID"]
                this.pdfDownloadCount = doc["@DownloadedPdfCount"] ?? 0
                this.pdfPrintCount = doc["@PrintedPdfCount"] ?? 0
                this.showModal = true;
                this.pdfDialog = true;
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
      this.alert = {
        show: false,
      };
      this.$store.dispatch("setGlobalLoading", false);
    },
    updateThaiSmartTaxPdf: async function (docID) {
      // get user token
      let token = await firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken;
        });
      const headers = {
        "Content-Type": "application/json",
        Authorization: "JWT " + token,
      };
      let data = {
        companyID: this.$route.params.companyId,
        docID: docID,
      };
      const promise = new Promise((resolve, reject) => {
        axios
          .post(fc.getFunctionUrl("updateThaiSmartTaxPdf"), data, {
            headers,
          })
          //.post('http://127.0.0.1:5001/sld-etax/us-central1/' + "updateThaiSmartTaxPdf", data, { headers })
          .then(
            (response) => {
              if (response.status === 200) {
                resolve(response.data);
              }
            },
            (error) => {
              reject(error);
              console.log(error);
              this.$store.dispatch("setGlobalLoading", false);
              this.downloadPdfLoading = false;
            }
          );
      });
      return promise;
    },
    getDateWithFormat: function (timestamp) {
      // Convert Firebase timestamp to milliseconds
      var milliseconds =
        timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000 + 100;

      // Create a JavaScript Date object from milliseconds
      var date = new Date(milliseconds);

      // Use moment.js to format the date
      var parsedDate = moment(date);

      // Format the date as per the desired output format
      var formattedDate = parsedDate.format("Do MMM", "th");

      // Convert the month to Thai abbreviation
      formattedDate = formattedDate.replace("Jan", "ม.ค.");
      formattedDate = formattedDate.replace("Feb", "ก.พ.");
      formattedDate = formattedDate.replace("Mar", "มี.ค.");
      formattedDate = formattedDate.replace("Apr", "เม.ย.");
      formattedDate = formattedDate.replace("May", "พ.ค.");
      formattedDate = formattedDate.replace("Jun", "มิ.ย.");
      formattedDate = formattedDate.replace("Jul", "ก.ค.");
      formattedDate = formattedDate.replace("Aug", "ส.ค.");
      formattedDate = formattedDate.replace("Sep", "ก.ย.");
      formattedDate = formattedDate.replace("Oct", "ต.ค.");
      formattedDate = formattedDate.replace("Nov", "พ.ย.");
      formattedDate = formattedDate.replace("Dec", "ธ.ค.");

      // Get the year in Thai Buddhist calendar
      var thaiYear = parseInt(parsedDate.format("YYYY")) + 543; // Add 543 to convert to Thai Buddhist calendar

      // Append the Thai Buddhist year to the formatted date
      formattedDate += " " + thaiYear.toString().substring(2, 4);

      return formattedDate;
    },
    formatDate: function (dateTimestamp) {
      if (dateTimestamp && typeof dateTimestamp.seconds === "number") {
        try {
          // Convert seconds to milliseconds and create a Date object
          const date = new Date(dateTimestamp.seconds * 1000);

          // Extract and format the date components
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
          const year = date.getFullYear();

          // Return the formatted date string
          return `${day}/${month}/${year}`;
        } catch (error) {
          console.error("Error formatting date:", error);
          return "";
        }
      } else {
        console.error("Invalid dateTimestamp object:", dateTimestamp);
        return "";
      }
    },
    onChangeValueFilterList(value) {
      this.clearValue();
      this.$store.dispatch("thaismartTax/setValueFilterList", {
        valueFilterList: value,
      });
    },
    onChangeValueDropdownHideColumn(value) {
      this.valueHideList = value;
    },
    onChangeValueSearchOption(value) {
      this.filterData.fromDate = value.fromDate;
      this.filterData.toDate = value.toDate;
      this.filterData.branchID = value.branchID;
      this.filterData.toNo = value.toNo;
      this.filterData.fromNo = value.fromNo;
      this.filterData.taxType = value.taxType;
      this.filterData.nsDocID = value.nsDocID;
      // this.$store.dispatch("thaismartTax/setSearchField", value);
      this.query();
    },
    showColumn(field) {
      return this.valueHideList.includes(field);
    },
    clearValue: function () {
      this.$store.dispatch("thaismartTax/updatePage", { page: 1 });
    },
    clearSelectList: function () {
      this.$store.dispatch("thaismartTax/setSelectedList", {
        selectedList: [],
      });
    },
    errorsMessage: function (errors) {
      return getErrorMessage(errors);
    },
    handlePayeeType: function (payeeType) {
      if (payeeType === "J") {
        return "Journal";
      } else if (payeeType === "B") {
        return "Bill Payment";
      } else {
        return "";
      }
    },
    handlePayeeAddress(payeeAddress) {
      if (payeeAddress) {
        // return payeeAddress.split(" ")[0] +  payeeAddress.split(" ")[1] +  payeeAddress.split(" ")[2] || ""
        let truncatedAddress =
          payeeAddress.length > 20
            ? payeeAddress.substring(0, 25) + "..."
            : payeeAddress;
        return truncatedAddress;
      }
      return "";
    },
    clearAllSelectList: function () {
      this.selectAll = false;
      this.$store.dispatch("thaismartTax/setSelectedList", {
        selectedList: [],
      });
      this.clearSelectList();
    },
    holdDownloadAndSendEmail: function (status) {
      return companyStatus.holdDownloadAndSendEmail(status);
    },
    autocompleteAddEmail: function (k, value) {
      this.emailInput = "";
      if (value && !this.emailList[k].includes(value)) {
        Vue.observable(this.emailList[k].push(value));
      }
    },
    removeEmail: function (k) {
      this.emailList[k] = [...this.emailValues[k]];
      Vue.observable(this.emailList[k]);
    },
    resetDateSearch: function () {
      this.$store.dispatch("thaismartTax/setFromDate", "");
      this.$store.dispatch("thaismartTax/setToDate", "");
      this.$store.dispatch("thaismartTax/updateKeyword", "");
      this.fromDateVal = null;
      this.toDateVal = null;
      this.clearValue();
    },
    handlePreviewDoc(pdfUrl) {
      this.pdfSrc = pdfUrl;
      this.pdfDialog = true;
    },
    handleSearchClick: function () {
      this.onChangeValueSearchOption({ ...this.filterData });
    },
    resetSearchData() {
      this.filterData = {
        fromDate: "",
        toDate: "",
        branchID: "",
        toNo: "",
        fromNo: "",
        taxType: "",
        payeeName: "",
      };
      this.fromDateVal = null;
      this.toDateVal = null;
      this.handleSearchClick();
    },
    onChangeSearchFilterOption(key,value) {
      if (value === "fromDateToDate") {
        this.selectedFilter.fromDateToDate = !this.selectedFilter.fromDateToDate;
      } else if (value === "branchID") {
        this.selectedFilter.branchID = !this.selectedFilter.branchID;
      } else if (value === "fromNoToNo") {
        this.selectedFilter.fromNoToNo = !this.selectedFilter.fromNoToNo;
      } else if (value === "taxType") {
        this.selectedFilter.taxType = !this.selectedFilter.taxType;
      } else if (value === "nsDocID") {
        this.selectedFilter.nsDocID = !this.selectedFilter.nsDocID;
      }
    },
    setTransactionStatus: async (context) => {
      const route = context.$route;
      if(route?.path.split("-").pop() === "cancel") {
        context.headerTitle = "ยกเลิกรายการภาษีหัก ณ ที่จ่าย";
        await context?.$store.dispatch("thaismartTax/setTransactionStatus", "Cancel");
      } else {
        context.headerTitle = "ภาษีหัก ณ ที่จ่าย";
        await context?.$store.dispatch("thaismartTax/setTransactionStatus", "");
      }
      context.resetSearchData();
    },
    
    updateDocument: async function (data) {
      try {
        let companyId = this.$route.params.companyId;
        await this.$store.dispatch('thaismartTax/updateThaiSmartTax', {
          companyId: companyId,
          data: data 
        });
      } catch (error) {
        console.error('Failed to update document:', error);
      }
    },
    async getFillingStatus() {
      // /Companies/CWtzGa8UHAt3gpRLVNxU/SettingThaiSmartTax/taxWHFilingStatusSetting
      const companyId = this.$route.params.companyId;
      const docRef = fc.db.doc(`Companies/${companyId}/SettingThaiSmartTax/taxWHFilingStatusSetting`);
      const doc = await docRef.get();
      if (doc.exists) {
        const data = (doc.data()?.filingStatuses || []).filter(i=> i.isActive === true);
        this.fillingStatus = data;
      }
    },
    async handleCancelDocClick() {
      this.isCancellingTransaction = true;
      try {
        await this.$store.dispatch("thaismartTax/cancelSelectedDoc", {
          companyId: this.$route.params.companyId,
        });
        this.snackBarMsg = `ยกเลิกรายการสำเร็จจำนวน ${this.selectedList.length} รายการ`;
        this.snackBarSuccess = true;
      } catch (e) {
        this.snackBarMsg = "ไม่สามารถยกเลิกรายการได้";
        this.snackBarError = true;
      } finally {
        this.isCancellingTransaction = false;
        this.cancelDocDialog = false;
        this.clearSelectList();
      }
    },
  },
};
</script>

<style lang="scss">
#table-wht {
  .v-responsive {
    overflow: visible !important;
  }
  .filter-up {
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  th {
    img {
      width: 10px;
      height: 8px;
    }
  }

  .border-right {
    border-right: 1px solid #ffffff;
  }

  //add arrow to tooltip
  //.v-tooltip__content::before {
  //  content: '';
  //  position: absolute;
  //  display: block;
  //  width: 0px;
  //  left: 50%;
  //  bottom: 6px;
  //  border: 5px solid transparent;
  //  border-bottom: 0;
  //  border-top: 8px solid #191919;
  //  transform: translate(-50%, calc(100% + 5px));
  //}

  // .v-text-field fieldset,
  // .v-text-field .v-input__control,  
  // .v-text-field .v-input__slot {
  //   border-radius: 10px !important;
  //   border-color: #c4c4c4;
  // }

  // .v-input__slot {
  //   margin-bottom: 0 !important;
  // }

  // .v-label .theme--light {
  //   overflow: auto !important;
  // }

  // .v-text-field {
  //   //margin-top: 6px !important;
  // }

  // .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
  //   padding: 0 !important;
  // }

  // .v-select__slot {
  //   min-height: auto !important;

  //   .v-text-field--outlined .v-label {
  //     top: 0 !important;
  //   }

  //   .v-label--active {
  //     top: 20px !important;
  //   }
  // }

  // .v-text-field--enclosed .v-input__append-inner {
  //   margin-top: 6px !important;
  // }

  // .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {
  //   min-height: 40px !important;
  // }

  // .v-text-field--outlined fieldset {
  //   top: -6px;
  // }

  // .v-text-field--outlined .v-label {
  //   top: 10px;
  // }

  //.v-text-field .v-input__prepend-inner, .v-text-field .v-input__append-inner {

  //margin-top: 4px !important;
  //}
  .search-box {
    width: 250px;
  }

  .remove-checkbox-padding {
    .v-input--selection-controls__input {
      margin-right: 0;
    }
  }

  .doc-id {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .v-text-field__details {
    display: none !important;
  }

  .icon-sort {
    cursor: pointer;
  }

  .v-card__title .v-messages {
    min-height: 11px;
  }

  .order-by-row {
    cursor: pointer;
  }

  .icon-downloaded {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 4px;
  }

  th,
  td {
    white-space: nowrap;
  }

  .check-box-flex {
    display: flex;
    align-items: center;
  }

  tr {
    &.tr-data {
      cursor: pointer;
    }
  }

  .icon-button {
    height: -webkit-fill-available;
  }
}

.numberRow {
  min-width: 3rem !important;
}

.iframe {
  overflow: hidden !important;
  height: 100% !important;
  width: 60% !important;
  position: absolute !important;
  left: 20% !important;
  right: 10% !important;
  top: 0 !important;
}

.status-icons {
  width: auto;
  min-width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 10px;
}

.count-wrapper {
  display: inline-flex;
  align-items: center;
}

.disabled-btn {
  color: rgba(0, 0, 0, 0.26) !important;
  cursor: default;
}

.v-btn {
  letter-spacing: unset !important;
}

.btn-choose {
  margin-right: 20px;
}

.btn-ns-search,
.btn-ns-reset {
  height: 40px !important;
  padding-inline: 13px !important;
}

.inputted-green {
  input,
  .v-select__selections {
    color: #6ec39b !important;
  }
}

/* ── Reset PDF dialog ─────────────────────────────────────────────── */
.reset-pdf-card {
  border-radius: 12px !important;
  overflow: hidden;
}
.reset-pdf-card__title {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px !important;
  background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
  color: #ffffff;
}
.reset-pdf-card__title-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  flex-shrink: 0;
}
.reset-pdf-card__heading {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: #ffffff;
}
.reset-pdf-card__subheading {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 400;
  margin-top: 2px;
}
.reset-pdf-card__body {
  padding: 20px !important;
}
.reset-pdf-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 6px 0;
  font-size: 14px;
}
.reset-pdf-row__label {
  min-width: 100px;
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
}
.reset-pdf-row__value {
  color: #1f2937;
  font-weight: 500;
  word-break: break-all;
}
.reset-pdf-row__value--mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 13px;
}
.reset-pdf-divider {
  margin: 14px 0 4px;
  border-top: 1px dashed #e5e7eb;
}
.reset-pdf-checkbox-wrap {
  padding: 4px 4px 0;
}
.reset-pdf-checkbox :deep(.v-label) {
  font-size: 14px;
  color: #1f2937;
}
.reset-pdf-checkbox__label {
  line-height: 1.3;
}
.reset-pdf-checkbox__main {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
}
.reset-pdf-checkbox__hint {
  font-size: 11px;
  color: #6b7280;
  margin-top: 1px;
}
.reset-pdf-note {
  margin-top: 10px;
  padding: 10px 12px;
  background: #f9fafb;
  border-left: 3px solid #d1d5db;
  border-radius: 4px;
  font-size: 12.5px;
  color: #374151;
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
  gap: 4px;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.reset-pdf-note--warning {
  background: #fffbeb;
  border-left-color: #d97706;
  color: #92400e;
}
</style>
